import React from 'react';
import GroupLightComponent from './configs/LightGroupConfig';
import "../../styles/desktop/CampoLuzes.css";

import {GruposPaginas} from '../../configs/iluminação'

import image from '../../assets/img/Fachada.jpg'; // Imagem de fundo da página
import CampoImagem from '../CampoImagem/campoimagem'; // Componente de imagem

const IntermediarioPagina = () => {
  return (
    <div className="intermediario-container">
      <CampoImagem imagem={image} loadingImage={false} />
      <GroupLightComponent
        groupIds={GruposPaginas[2]}
        //startIndex={20}  // Começa onde o térreo termina
        //endIndex={40}    // Ajuste conforme o número total de luzes
        pageTitle="Faixada" 
      />
      
    </div>
  );
};

export default IntermediarioPagina;